const translations = {
  fr: {
    promotion: {
      title: 'Titre',
      newPromotion: 'Nouvelle promotion',
      expirationMessage: 'Cette offre pourra être acceptée jusqu\'au {{expirationDate, dddd LL}}',
      dateRange: 'Plage',
      nbOfSpots: 'Spots',
      cost: 'Prix',
      discount: 'Rabais',
      expirationDate: 'Date d\'expiration de l\'offre',
      campaign: 'Campagne',
      customers: 'Clients',
      timeSlot: 'Plage horaire',
      missingTitleError: 'Vous devez nommer votre promotion',
      missingCampaignError: 'Vous devez choisir une campagne',
      hasNoPromotionsInState: 'Aucune promotion',
      promotionLoadingError: 'Une erreur est survenue lors du chargement des promotions',
      promotionCreationError: 'Une erreur est survenue lors de la création de la promotion',
      promotionSent: 'La promotion a été envoyée au client',
      accepted: 'Acceptées',
      proposed: 'Proposées',
      expired: 'Expirées',
      declined: 'Refusées',
      salesPromotions: 'Promotions',
      mustBeGreaterThanZero: 'Doit être supérieur à zéro',
    },
  },
  en: {
    promotion: {
      title: 'Title',
      newPromotion: 'New promotion',
      expirationMessage: 'This offer will be available until {{expirationDate, dddd LL}}',
      dateRange: 'Date range',
      nbOfSpots: 'Spots',
      cost: 'Cost',
      discount: 'Discount',
      expirationDate: 'Offer\'s expiration date',
      campaign: 'Campaign',
      customers: 'Customers',
      timeSlot: 'Time slot',
      missingTitleError: 'You must give a title to your promotion',
      missingCampaignError: 'You must select a campaign',
      hasNoPromotionsInState: 'No promotions',
      promotionLoadingError: 'An error occurred when loading the promotions',
      promotionCreationError: 'An error occurred when creating the promotion',
      promotionSent: 'The promotion has been sent to the customer',
      accepted: 'Accepted',
      proposed: 'Proposed',
      expired: 'Expired',
      declined: 'Declined',
      salesPromotions: 'Sales Promotions',
      mustBeGreaterThanZero: 'Must be greater than zero',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/promotions/i18n/promotion.js